module.exports = __webpack_public_path__ + "img/my-gift.4f5847cb.png";